import { SendPrescriptionStepUI } from './SendPrescriptionStepUI'
import { useSendPrescriptionStep } from './useSendPrescriptionStep'

export const SendPrescriptionStep = () => {
  const props = useSendPrescriptionStep()
  return <SendPrescriptionStepUI {...props} />
}
